"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPollingConfig = void 0;
const repository_1 = require("../../../../features/authoriser/infra/repositories/checkTrustedVerificationStatus/repository");
const getPollingConfig = (api, progressId, biometricId, url) => ({
    interval: 5000,
    maxAttempts: 180,
    getDataFn: () => repository_1.trustedVerificationStatusRepository.isVerified(api, progressId, { biometricId }, url),
});
exports.getPollingConfig = getPollingConfig;
//# sourceMappingURL=polling.helper.js.map